import { FC } from 'react';
// component
import ViewStaffComponent from 'components/main/Staff/View';

const EditStaff: FC = () => <ViewStaffComponent />;

export default EditStaff;
